<div class="search-container align-items-center ">
  <div class="container ">
    <div class="row ">
        <div class="col-12 col-lg-9 main-wrapper p-0 mx-auto">
            <!--<header class="clearfix header-brand">
              <div class="brand float-left">
                  <p class=" mb-0">
                      <img src="assets/image/cr-logo-bw.png" alt="">
                      <small>Built exclusively for the Military</small>
                    </p>
                      
              </div>
              <div class="float-right have-account">
                <a href="javascript:void(0)" (click)="loginsubmit()">Already have an account?</a>
              </div>
                
              </header>-->
          <router-outlet></router-outlet>
          
        </div>
    </div>
    <!-- <div class="row">
      <div class="col">
          <div id="footer" class="text-center mt-2">
              <p>© {{ year }} CollegeRecon. All rights reserved.</p>
          </div>
      </div>
    </div> -->
  </div>
  
</div>



// WEBPACK FOOTER //
// ./src/app/app.component.html